import React, { useEffect, useRef } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import TextOnlyBannerContent from './components/TextOnlyBannerContent';

export interface Props {
  data: any;
}

const TextOnlyBanner: React.FC<Props> = ({ data }) => {
  const { headingTitile, content, ctaLink, ctaText } = data;
  const headingRef = useRef<HTMLAnchorElement>(null);
  
    useEffect(() => {
      headingRef.current?.focus();
    }, [headingRef]);

  return (
    <div className="mx-20 sm:mx-24 md:mx-75 lg:mx-76 xl:mx-0">
      <div className="container w-full" data-ffid="ctr-text-only-banner">
        <div
          className="w-full items-center justify-center gap-0"
        >
          <div className={``}>
            <div className={`section-heading`} data-ffid="ctr-text-only-banner-heading">
              <div>
                <h2
                  className={`whitespace-normal break-words pb-24 text-28 lg:text-40 text-[#333] text-center`}
                  data-ffid={`lbl-text-only-banner-heading-text`}
                >
                  {headingTitile}
                </h2>
              </div>
            </div>
          </div>

        </div>
        <div className="w-full items-center justify-center gap-0 py-20 lg:pb-68 lg:pt-40">
          <TextOnlyBannerContent items={content} />
          <div className='text-center'>
            <Link
              data-ffid="lnk-text-only-banner-cta-link"
              link={ctaLink}
              className="text-[#018463] inline-flex justify-center items-center bg-white rounded-full border-2 border-[#018463] px-20 py-12 hover:border-[#349D82]"
            >
              <span className="text-16">{ctaText}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextOnlyBanner;
